<template lang="pug">
div#wrapper.has-text-centered-mobile.is-black-ducter(:style="{ backgroundImage: 'url(' + require('@/assets/ducter_small.svg') + ')', repeat: 'repeat' }")
  section#hero.hero.is-fullheight
    .container
      .div#logo
        .columns.has-text-centered
          .column.is-full.has-text-centered
            figure.image
              img#logoDucter(src='../../assets/ducter_Blanco.png')
      .div-title
        .columns.has-text-centered.is-tablet
          .column.is-8.is-offset-2.is-12-mobile
            h1.title.is-size-1.is-title Ductos y Terminales
            p.has-text-centered-mobile.is-size-3
              | Empresa de 100% Mexicana, dedicada a la entrega de gas L.P., comprometida con el medio ambiente y socialmente responsable.
      .div
        .columns.has-text-centered
          .column.is-offset-4.is-4.is-offset-3-mobile.is-6-mobile
            hr.rounded
      .div.is-button
        .columns.has-text-centered.is-tablet
          .column.is-12
            router-link.a.button.is-primary.is-block.is-size-5(to='login') Entrar a sistema
</template>

<script>
import NavBar from './NavBar.vue'
import Somos from './Somos.vue'
import Operaciones from './Operaciones.vue'
import Seguridad from './Seguridad.vue'
import Sustentabilidad from './Sustentabilidad.vue'
import Contacto from './Contacto.vue'
import Footer from './Footer.vue'
import ModalContacto from './ModalContacto.vue'
import ButtonRoundedBottom from './ButtonRoundedBottom.vue'
import ButtonRoundedTop from './ButtonRoundedTop.vue'
  export default {
    name: 'Landing',
    components: {
      NavBar,
      ButtonRoundedBottom,
      Somos,
      Operaciones,
      Seguridad,
      Sustentabilidad,
      Footer,
      Contacto,
      ModalContacto,
      ButtonRoundedTop,
    },
    data() {
      return {
        showModal: false,
        seccionSel: '',
        observer: null,
        classNavBar: 'transparent',
      }
    },
    methods: {
      verModal() {
        this.showModal = true
      },
      cerrarModal() {
        this.showModal = false
      },
      irSeccion (section) {
        console.log(section)
        if (section === 'homeTop') {
          this.$refs['homeTop'].scrollIntoView({ behavior: 'smooth' })
        } else {
          this.seccionSel = section
        }
      },
      irTop() {
        this.$refs['homeTop'].scrollIntoView({ behavior: 'smooth' })
      },
      irBottom() {
        this.$refs['footer'].scrollIntoView({ behavior: 'smooth' })
      },

      onElementObserved(entries) {
        entries.forEach(({ target, isIntersecting}) => {
          console.log(entries)
          if (entries.length = 1) {
            console.log('1 elemento')
            const idTarget = target.id
            if (idTarget) {
              console.log('Hero')
              console.log(isIntersecting)
              this.classNavBar = 'is-transparent'
            } else {
              console.log('Somos')
              console.log(isIntersecting)
              this.classNavBar = isIntersecting ? 'is-transparent' :'is-white'

            }
          }
        })
      },
    },
    created () {
      this.observer = new IntersectionObserver(
        this.onElementObserved, {
          root: null,
          threshold: 1.0,
        }
      )
    },

    mounted () {
      const toObserver = document.querySelectorAll('.observable')
      const elements = Array.from(toObserver)
      elements.map( element => {
        this.observer.observe(element)
      })
    },

    beforeDestroy() {
      this.observer.disconnect();
    },
  }
</script>

<style scoped>
  .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  #wrapper {
    position: relative;
  }

  #hero {
    width: 100%;
    background-size: cover;
    position: relative;
    padding-top: 82px;
    padding-bottom: 82px;
  }

  #hero::before {
    content:'' !important;
    position: absolute !important;
    top: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    background-color: rgba(0,0,0,0.6) !important;
  }

  .contenido {
    margin-top: 80px;
  }
  hr .rounded {
    border-top: 2px solid  #4A4A4A;
    border-radius: 2px;
  }

  .is-white {
    color: white;
  }

  .div-title h1 {
    color: white;
    font-size: 2.5rem !important;
    font-weight: 500;
  }

  .div-title {
    display: flex;
    flex-direction: column;
    justify-content: start;
    justify-items: center;
    padding: 16px;
    margin-top: 60px;
    color: white;
  }

  .div-title h1 {
    color: white;
  }

  .is-title {
    margin-top: 20px;
  }

  @media (max-width:641px) {
    .is-title {
      margin-top: 30px;
    }
  }

  .is-black-ducter {
    background-color: #000000;
  }

  #logoDucter {
    max-width: 300px;
    height: auto;
  }

  #logo {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .is-button {
    display: flex;
    justify-content: center;
    align-items: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/landing_Componentes/Landing.vue